module.exports = __webpack_public_path__ + "static/media/intro.8000dade.mp3";